import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { Currency } from '@swf/core/enums';
import type { HGGetClubTournStructuresReply } from '@swf/generated/types/api/v0/SwHomeGames';
import { PlayMoney, PotTypeTranslations } from '@swf/poker';

const getOptionsByHandType = (
  structures: HGGetClubTournStructuresReply | undefined,
  handType: string,
  isHiLo: boolean
) => {
  if (!structures?.gameStructures || !handType) {
    return { tableSizeOptions: [], potTypeOptions: [], currencyOptions: [] };
  }

  const gameStructure = structures.gameStructures.find(
    (structure) => structure.handType === handType && structure.hiLo === isHiLo
  );

  if (!gameStructure) {
    return { currencyOptions: [], tableSizeOptions: [], potTypeOptions: [] };
  }

  const potTypeOptions =
    gameStructure.potTypes?.map((potType: string) => ({
      text: <Translation {...PotTypeTranslations[potType]} />,
      value: potType
    })) || [];

  const tableSizeOptions =
    gameStructure.tableSizes
      ?.sort((a: number, b: number) => b - a)
      .map((tableSize: number) => ({
        text: tableSize.toString(),
        value: tableSize
      })) || [];

  const { currencyBuyIns } = structures;

  const currencyOptions =
    gameStructure.moneyTypes?.flatMap((moneyType: boolean) =>
      moneyType
        ? PlayMoney
        : currencyBuyIns?.map(({ currency }) => ({
            text: currency,
            value: Currency[currency as string] || currency
          })) || []
    ) || [];

  return { tableSizeOptions, potTypeOptions, currencyOptions };
};

export default getOptionsByHandType;
